import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import MuiDivider from '@material-ui/core/Divider';

const styles = () => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    divider: {
        flexGrow: 1,
    },
});

class Divider extends React.Component {
    render() {
        const { children, classes, className, ...rest } = this.props;

        if (!children) {
            return <MuiDivider {...rest} />;
        }

        return (
            <div className={classes.container}>
                <MuiDivider className={classNames(className, classes.divider)} {...rest} />
                {children}
                <MuiDivider className={classNames(className, classes.divider)} {...rest} />
            </div>
        );
    }
}

export default withStyles(styles)(Divider);
